/**
 * Floating Nav
 * 
 * @Author: Focci
 * @Date: 2023-08-30 17:50:26
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-30 17:50:26
 */

'use client'

// import PropTypes from 'prop-types'
import useApp from '@hook/useApp'
import useMutationModule from '@hook/useMutationModule'
import useTracking from '@hook/useTracking'
import { getListingData } from '@comp/user-tracking/lib'
import { FloatingMenuPanel } from '@comp/floating-nav'
import { useEffect, useRef } from 'react'
import { forEach } from 'lodash-es'

// 事件名称与滚动位置名称映射
const evtNameMaps = {
  // 'module-openhome': 'auction-add_calendar',
  'module-locations': 'location',
  // 'module-openhome': 'auction',
  'module-openhome': 'open_homes',
  'module-estimate': 'estimate',
  'module-govdata': 'council_data',
  'module-schoolInfo': 'school_zones',
  'module-propertyRecording': 'property_history',
  'module-development': 'for_developers',
  'module-areaAnalysis': 'suburbs',
  'module-loan': 'mortgage',
  'module-perimeterSold': 'sold_nearby',
  'module-moreRecommend': 'more_recommend',
  'module-guessYouLike': 'you_may_like'
}

export default function FloatingNav({ house }) {
  const { clientWidth } = useApp()

  // 添加滚动事件
  // ======================================================================
  const fireStatus = useRef({})
  const { value } = useMutationModule()
  const { pushTrack } = useTracking()

  useEffect(() => {
    const anchor = evtNameMaps[value]

    if(anchor && !fireStatus.current[anchor]) {
      fireStatus.current[anchor] = true

      const houseParam = getListingData(house)
      const param = []
      const { auction, openHomes } = house

      // 针对开放日单独处理
      if(anchor === evtNameMaps['module-openhome']) {
        if(auction) param.push({ ...houseParam, page_anchor: 'auction' })
        if(openHomes?.length > 0) param.push({ ...houseParam, page_anchor: anchor })
        // 
      } else {
        param.push({ ...houseParam, page_anchor: anchor })
      }

      forEach(param, (p) => {
        pushTrack('house_page_scroll', p, { enabledGA4: true, enableApi: false })
      })
    }
  }, [house, pushTrack, value])
  // ======================================================================

  if(clientWidth < 1600) {
    return null
  }
  
  return (
    <div className="sticky top-0 z-[20]">
      <div className="w-274 mx-auto">
        <div className="absolute mt-16 pointer-events-none">
          <div className="inline-flex pointer-events-auto" style={{ marginLeft: '-115%' }}>
            <FloatingMenuPanel
              itemClassName="
                justify-start px-2 py-1 hover:bg-cf0 
                border-l border-l-2 border-transparent
              "
              activedItemClassName="
                justify-start px-2 py-1 bg-primary/10 text-primary
                border-l border-l-2 border-primary
              "
            />
          </div>
        </div>
      </div>
    </div>
  )
}

// FloatingNav.propTypes = {
//   className: PropTypes.string,
// }
